var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"font-sans-normal text-xs rounded py-5 px-10 mr-5 mt-5"},'div',_vm.attrs,false),[(!!_vm.icon)?_c('Icon',_vm._b({staticClass:"fas text-xs mr-5",attrs:{"title":_vm.$t(`common.icons.screen_reader_names.${_vm.icon}`),"iconClass":`fa-${_vm.icon}`}},'Icon',_vm.attrs,false)):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }